import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';

@Component({
    selector: 'sirius-tab',
    templateUrl: './tab.component.html',
    styleUrl: './tab.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.role]': "panelIdState() ? 'tabpanel' : null",
        '[attr.id]': 'panelIdState() ?? null',
        '[attr.aria-labelledby]': 'labelledByIdState() ?? null',
        '[attr.tabindex]': "panelIdState() ? '0' : null",
        '[hidden]': '!isActive()',
    },
})
export class TabComponent {
    @Input() title = '';

    protected readonly isActive = signal(false);
    protected readonly panelIdState = signal<string | undefined>(undefined);
    protected readonly labelledByIdState = signal<string | undefined>(undefined);

    // Content is always rendered (hidden when inactive) so tab panels exist in
    // SSR HTML and are indexable; `active` only toggles visibility.
    @Input() set active(value: boolean) {
        this.isActive.set(value);
    }

    @Input() set panelId(value: string | undefined) {
        this.panelIdState.set(value);
    }

    @Input() set labelledById(value: string | undefined) {
        this.labelledByIdState.set(value);
    }
}
